function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrameioLogoWhite = function SvgFrameioLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.173 23.286c-.837 0-1.392-.876-1.09-1.657A23.8 23.8 0 0 0 5.692 13c0-3.043-.57-5.953-1.607-8.63-.303-.78.252-1.656 1.089-1.656.456 0 .87.271 1.036.695A26.1 26.1 0 0 1 8.021 13c0 3.385-.642 6.62-1.812 9.59-.167.425-.58.696-1.036.696M10.759 20.957c-.768 0-1.32-.736-1.147-1.483.483-2.08.738-4.247.738-6.474a28.6 28.6 0 0 0-.738-6.474c-.173-.747.38-1.483 1.146-1.483.522 0 .981.35 1.101.859.537 2.279.82 4.655.82 7.098s-.283 4.82-.82 7.099c-.12.507-.579.858-1.1.858M16.037 17.464c-.702 0-1.241-.619-1.175-1.317a33.6 33.6 0 0 0 0-6.294c-.066-.698.473-1.317 1.175-1.317.585 0 1.08.435 1.136 1.017a36 36 0 0 1 0 6.894 1.133 1.133 0 0 1-1.136 1.017M20.993 11.511l.666.666a1.164 1.164 0 0 1 0 1.646l-.666.666a.776.776 0 0 1-1.325-.55V12.06a.776.776 0 0 1 1.325-.549",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
};
export default SvgFrameioLogoWhite;